import React, { memo } from 'react';
import { connect } from 'react-redux';
import { useTransition } from '@react-spring/web';
import PropTypes from 'prop-types';

import { TRANSITION_PROPS } from 'features/team/constants';
import { selectTaxEntryDrawerIsOpen } from 'features/team/selectors';

import TaxEntryDrawerContainer from './TaxEntryDrawerContainer';

const TaxEntryRoot = ({ isOpen }) => {
  const transitions = useTransition(isOpen, TRANSITION_PROPS);

  return transitions((animations, isDrawerOpen) =>
    isDrawerOpen ? <TaxEntryDrawerContainer animations={animations} /> : null
  );
};

TaxEntryRoot.propTypes = {
  isOpen: PropTypes.bool,
};

export default connect(state => ({
  isOpen: selectTaxEntryDrawerIsOpen(state),
}))(memo(TaxEntryRoot));
